import { BOOKTICKET, DELETETICKET } from "./actionsTypes";

export const addTicket = (value) => {
  return {
    type: BOOKTICKET,
    payload: value,
  };
};

export const deleteTicket = (value) => {
  return {
    type: DELETETICKET,
    payload: value,
  };
};
